import useCurrentQueryId from "views/logic/queries/useCurrentQueryId";
const useActiveQueryId = () => useCurrentQueryId();
export default useActiveQueryId;
